import { render, staticRenderFns } from "./CallDetailRecord.vue?vue&type=template&id=4778585e&scoped=true"
import script from "./CallDetailRecord.vue?vue&type=script&lang=ts"
export * from "./CallDetailRecord.vue?vue&type=script&lang=ts"
import style0 from "./CallDetailRecord.vue?vue&type=style&index=0&id=4778585e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4778585e",
  null
  
)

export default component.exports